import axios from '@dap/shared-utils/http.js';
import { postJson } from '@dap/shared-utils/http';

export default {
    // 获取生命周期字典
    getLifeCycleDict (params = {}) {
        return axios.get('/dapper/api/life_cycles/data_dict', { params });
    },
    // 获取游戏包列表
    getPackageList (params = {}) {
        return axios.get('/dapper/api/life_cycles', { params });
    },
    // 获取游戏包历史概要
    getHistoryList (params = {}) {
        return axios.get('/dapper/api/life_cycles/detail/summary', { params });
    },
    // 新增生命周期
    addOrUpdateLifeCycles (params = {}, isEdit = false) {
        if (isEdit) {
            return axios.put('/dapper/api/life_cycles', params);
        } else {
            return axios.post('/dapper/api/life_cycles', params);
        }
    },
    // 游戏包日志
    getLifeCyclesLog (params = {}) {
        return axios.get('/dapper/api/life_cycles/log', { params });
    },
    // 游戏包生命周期详情
    getLifeCyclesDetail (params = {}) {
        return axios.get('/dapper/api/life_cycles/detail/data_info', {
            params,
        });
    },
    // 游戏包确认操作
    confirmDetail (params = {}) {
        return postJson('/dapper/api/life_cycles/detail/confirm', params);
    },
    // 获取游戏包下所有测试公测预约时间
    getPackageDateRange (params = {}) {
        return axios.get('/dapper/api/life_cycles/detail/package_date_range', {
            params,
        });
    },
    // 获取游戏包最新轮次
    getTestRounds (params = {}) {
        return axios.get('/dapper/api/life_cycles/test_rounds', { params });
    },
    // 获取推广渠道
    getChannel (params = {}) {
        return axios.post('/coach/api/mediasrc', params);
    },
    // 校验测试轮次
    checkTestRounds (params = {}) {
        return axios.post('/dapper/api/life_cycles/test_rounds_check', params);
    },

    // 二期接口
    getGameTableList (params = {}) {
        return axios.get('/dapper/api/game_life_cycles', { params });
    },
    getGameInfo (params = {}) {
        return axios.get('/dapper/api/game_life_cycles/detail', { params });
    },
    updateGameInfo (params = {}) {
        return axios.put('/dapper/api/game_life_cycles', params);
    },
    getGameCycleInfo (params = {}) {
        return axios.get('/dapper/api/game_life_cycles/summary', { params });
    },
};
